
import { Message } from 'element-ui'
import customer from '../../api/moudles/customer.js'


const state = () => ({
   
	unreadNum:0,
    newList:null,
    userList:[],//会话列表
    list:[],//聊天窗口的消息队列,
    targetIndex:0,
    lastTime:0,
    alltotal:0,
    delayTimeout:1000

   
})

const getters ={
	
}

const actions = {
	//获取卖家消息
	getMessageInfo({state,dispatch}, payload) {
        if(payload.userId){
            customer
            .getUserMessage(payload)
            .then(res => {
                if(res.code === 200) {
                   console.log(res.data)
                   state.delayTimeout=1000
                    state.lastTime=res.data.lastTime
                    payload.lastTime=state.lastTime
                    state.unreadNum=res.data.unreadCount
                    state.newList=res.data.messages
                    state.userList=[]
                    state.alltotal=res.data.unreadCount

                    res.data.messages.forEach(p => {
                        state.userList.push({
                            id:1,
                            active:false,
                            userName:p.reciprocalName,
                            userAccount:p.reciprocalId,
                            sessionInfo:p.messages[p.messages.length-1].msg,
                            unreadMsg:p.unreadCount
    
                        })
                    })
                    state.userList.forEach((p,index ) => {
                        if(p.userAccount === this.targetUserId){
                            state.targetIndex=index
                        }
                    })

                   
                }
                 setTimeout(() => {
                    state.delayTimeout += 3000
                    if(state.delayTimeout > 300000){
                        state.delayTimeout=1000

                    }
                    
                    
                    dispatch('getMessageInfo',payload)
                    },state.delayTimeout) 
            })

        }
		
			
	}
}

const mutations= {

    updataUserList:(state,params) => {
        state.userList.push(params)

        console.log('userList',state.userList)
    },

    initUserList:(state,params) => {
        state.userList.push(params)
        state.userList=[]
        let obj=[]
        let list =[]
        console.log(state.userList)
        if(state.userList.length > 0){
            state.userList.forEach((p,index) => {
                    if(p.userAccount == state.targetUserId){
                        list.push(p)
                        obj=[{
                            userName:p.userName,
                            userAccount:p.userAccount,
                            ttp:index
                        }]
                    }
                })
                    console.log(obj)
                this.targetUser(obj[0],obj[0].ttp)
        }
    },
	
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}


